import React from 'react';
import OfflineMapGuideDialog from './OfflineMapGuideDialog';
import trackAnalytics from '../../utils/gaia/trackAnalytics';
import fetchUser from '../../utils/gaia/fetchUser';

interface SaveRegionButtonProps {
    saved: boolean;
    localizableStrings: {
        save_title: string;
        saving_description: string;
        unsave_title: string;
        send_to_app_title: string;
        download_and_login: string;
        done_title: string;
        finished_saving_description: string;
    };
    regionType: string;
    regionId: number;
    hasActiveSubscription: boolean;
    hasApp: boolean;
}

interface SaveRegionButtonState {
    saved: boolean;
    dialogOpen: boolean;
    dialogTitle: string;
    dialogDescription: string;
    dialogButtonTitle?: string;
    showingDownload?: boolean;
    user: User | undefined;
}

export default class SaveRegionButton
    extends React.Component<SaveRegionButtonProps, SaveRegionButtonState> {

    apiUrl: string;

    constructor(props: SaveRegionButtonProps) {
        super(props);
        this.state = {
            saved: props.saved,
            dialogOpen: false,
            dialogTitle: props.localizableStrings.save_title,
            dialogDescription: props.localizableStrings.saving_description,
            user: undefined,
        };
        // eslint-disable-next-line max-len
        this.apiUrl = `/api/trip/${this.props.regionType}/save/${this.props.regionId}/?mapdownload=1`;
    }

    async componentWillMount() {
        this.setState({user: await fetchUser()});
    }

    render() {
        return (
            <div
                className="col-xs-12 col-sm-3 pull-right-md"
                style={{paddingRight: 0, paddingLeft: 0, textAlign: 'right'}}
            >
                {this.state.saved ? (
                    <a
                        className="ga-button ga-button-primary expand-small expand-small-center"
                        href="#"
                        onClick={e => { e.preventDefault(); this.deleteSavedRegion(); }}
                        style={{color: 'white', padding: '15px', marginTop: '3px'}}
                        title="{this.props.deleteTitle}"
                    >
                        <i className="material-icons ibmid">smartphone</i>
                        <span className="ibmid">{this.props.localizableStrings.unsave_title}</span>
                    </a>
                ) : (
                    <a
                        className="ga-button ga-button-primary expand-small expand-small-center"
                        href="#"
                        onClick={e => { e.preventDefault(); this.saveRegion(); }}
                        style={{color: 'white', padding: '15px', marginTop: '3px'}}
                        title="{this.props.localizableStrings.saveTitle}"
                    >
                        <i className="material-icons ibmid">smartphone</i>
                        <span className="ibmid">{this.props.localizableStrings.save_title}</span>
                    </a>
                )}
                <OfflineMapGuideDialog
                    buttonTitle={this.state.dialogButtonTitle}
                    description={this.state.dialogDescription}
                    onRequestClose={() => this.closeDialog()}
                    open={this.state.dialogOpen}
                    saved={this.state.saved}
                    showingDownload={this.state.showingDownload}
                />
            </div>
        );
    }

    capitalize(word: string) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    async trackAnalytics(name: string) {
        trackAnalytics(name, {
            category: 'Hike',
            hasApp: this.props.hasApp,
            hasActiveSubscription: this.props.hasActiveSubscription,
            loggedIn: !(await fetchUser()).isAuthenticated,
            regionType: this.props.regionType,
            url: window.location.pathname
        });
    }

    saveRegion() {
        this.trackAnalytics('Save ' + this.capitalize(this.props.regionType));

        if (this.state.user && !this.state.user.isAuthenticated) {
            window.location.assign('/register/?next=' + window.location.pathname);
            return;
        }
        this.setState({
            dialogOpen: true
        });
        fetch(this.apiUrl, {
            method: 'POST',
            credentials: 'same-origin'
        }).then(response => {
            if (response.status === 201) {
                this.setState({
                    saved: true,
                    dialogDescription: this.props.localizableStrings.finished_saving_description,
                    dialogButtonTitle: this.props.localizableStrings.done_title
                });
            }
        });
    }

    deleteSavedRegion() {
        this.trackAnalytics(`Delete ${this.capitalize(this.props.regionType)} Region`);
        fetch(this.apiUrl, {
            method: 'DELETE',
            credentials: 'same-origin'
        }).then(response => {
            if (response.status === 200) {
                this.setState({
                    saved: false,
                    showingDownload: false,
                    dialogTitle: this.props.localizableStrings.save_title,
                    dialogDescription: this.props.localizableStrings.saving_description
                });
            }
        });
    }

    closeDialog() {
        if (this.state.showingDownload) {
            this.setState({dialogOpen: false});
            this.trackAnalytics(`${this.capitalize(this.props.regionType)} Region Finish Flow`);
        } else if (this.state.user && this.state.user.hasMobileApp) {
            this.setState({dialogOpen: false});
        } else {
            this.setState({
                dialogTitle: this.props.localizableStrings.send_to_app_title,
                dialogDescription: this.props.localizableStrings.download_and_login,
                dialogButtonTitle: this.props.localizableStrings.done_title,
                showingDownload: true
            });
            this.trackAnalytics(
                `${this.capitalize(this.props.regionType)} Region Show App Buttons`,
            );
        }
    }
}
